import BlogBrowser from './blog-browser';
import {connect} from 'react-redux';

const mapStateToProps = state => {
  return {
    blogs: state.podcast.rss && state.podcast.rss.channel && state.podcast.rss.channel.item?state.podcast.rss.channel.item.filter(item => !item.enclosure):[]
  }
}

export default connect(mapStateToProps)(BlogBrowser);